import React, { useEffect, useState } from 'react'
import HeaderTitle from '../../components/HeaderTitle'
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import { Helmet } from 'react-helmet';
import { hasMuhasebeRole, isAdmin } from '../../utils/roleUtils';

function Companies() {

    const { type } = useParams();

    const [companies, setCompanies] = useState([]);

    const { token, role } = useSelector((state) => state.auth)

    const muhasebeReadOnly = hasMuhasebeRole(role) && !isAdmin(role)

    const getCompanies = () => {
        axios.get(`${process.env.REACT_APP_SERVICE_URL}/company?companyType=${type}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                //console.log(response.data)
                setCompanies(response.data)
            })
            .catch((error) => {
                console.error(error)
                swal("Firmalar getirilirken hata oluştu", {
                    icon: "error",
                });
            })
    }

    const deleteCompany = (id) => {
        if (muhasebeReadOnly) {
            swal("Bu işlem için yetkiniz bulunmamaktadır", {
                icon: "error",
            });
            return;
        }

        console.log("delete company")
        swal({
            title: "Emin misiniz?",
            text: "Firmayı silmek istediğinizden emin misiniz?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.delete(`${process.env.REACT_APP_SERVICE_URL}/company/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then((response) => {
                            console.log(response.data)
                            swal("Firma başarıyla silindi", {
                                icon: "success",
                            });
                            getCompanies()
                        })
                        .catch((error) => {
                            console.error(error)
                            swal("Firma silinirken hata oluştu", {
                                icon: "error",
                            });
                        })
                } else {
                    swal("Firma silme işlemi iptal edildi");
                }
            });
    }

    useEffect(() => {
        getCompanies()
    }, [type])


    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Firmalar</title>
                <meta name='description' content='Firmaların listesi' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>

            <HeaderTitle title="Firmalar" description="Firmaların listesi" />

            <div className='row'>
                <div className='col-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='d-flex flex-wrap align-items-center gap-2'>
                                <button type='button' title="Yenile" aria-label="Listeyi yenile" className='btn btn-outline-secondary btn-app btn-app--icon' onClick={() => getCompanies()}>
                                    <i className='bi bi-arrow-clockwise'></i>
                                </button>
                                {!muhasebeReadOnly && (
                                    <Link to={`/companies/create/${type}`} className='btn btn-dark btn-app'>
                                        <i className='bi bi-plus-lg'></i>
                                        Yeni ekle
                                    </Link>
                                )}
                            </div>

                            <div className='table-responsive mt-3'>
                                <table className='table table-striped'>
                                    <thead>
                                        <tr>
                                            <th scope='col'>#</th>
                                            <th scope='col'>Firma Adı</th>
                                            <th scope='col' className='text-end'>İşlemler</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            companies?.map((company, index) => (
                                                <tr key={company.id}>
                                                    <th className='align-middle' scope='row'>{index + 1}</th>
                                                    <td className='align-middle'>{company.name}</td>
                                                    <td className='align-middle text-end'>
                                                        <div className='d-inline-flex flex-wrap align-items-center gap-1 justify-content-end'>
                                                            <Link to={`/companies/yibf/${company.id}`} className='btn btn-outline-secondary btn-app' title="YİBF listesi">
                                                                <i className='bi bi-list-ul'></i>
                                                                YİBF
                                                            </Link>
                                                            {!muhasebeReadOnly && (
                                                                <>
                                                                    <Link to={`/companies/edit/${company.id}`} state={company} className='btn btn-outline-primary btn-app'>Düzenle</Link>
                                                                    <button type="button" onClick={() => deleteCompany(company.id)} className='btn btn-outline-danger btn-app'>Sil</button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Companies